import React from "react"
import styled from "@emotion/styled"

const Container = styled.div`
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: auto;
  font-size: 16px;
  line-height: 28px;
  justify-content: center;
  align-items: center;
  font-weight: 200;
  flex-wrap: wrap;
  justify-content: space-around;
`

const Flex = ({ children }) => <Container>{children}</Container>

export default Flex
